/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Cue_No_PersonInputs */

const en_us2_body_assessment_cue_no_person = /** @type {(inputs: Body_Assessment_Cue_No_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Step into the frame.`)
};

const pt_br2_body_assessment_cue_no_person = /** @type {(inputs: Body_Assessment_Cue_No_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre no enquadramento.`)
};

const es_419_body_assessment_cue_no_person = /** @type {(inputs: Body_Assessment_Cue_No_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entra en el encuadre.`)
};

const pt_pt2_body_assessment_cue_no_person = /** @type {(inputs: Body_Assessment_Cue_No_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entra no enquadramento.`)
};

const fr_fr2_body_assessment_cue_no_person = /** @type {(inputs: Body_Assessment_Cue_No_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre dans le cadre.`)
};

const de_de2_body_assessment_cue_no_person = /** @type {(inputs: Body_Assessment_Cue_No_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tritt ins Bild.`)
};

const it_it2_body_assessment_cue_no_person = /** @type {(inputs: Body_Assessment_Cue_No_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entra nell'inquadratura.`)
};

/**
* | output |
* | --- |
* | "Step into the frame." |
*
* @param {Body_Assessment_Cue_No_PersonInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_cue_no_person = /** @type {((inputs?: Body_Assessment_Cue_No_PersonInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Cue_No_PersonInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_cue_no_person(inputs)
	if (locale === "es-419") return es_419_body_assessment_cue_no_person(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_cue_no_person(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_cue_no_person(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_cue_no_person(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_cue_no_person(inputs)
	return en_us2_body_assessment_cue_no_person(inputs)
});
export { body_assessment_cue_no_person as "body-assessment.cue.no_person" }